<section *ngIf="cesionarios.length == 0">
    <div style="text-align: center;">
        <h3>Sin cesionarios encontrados</h3>
    </div>
</section>
<section [hidden]="!(cesionarios.length > 0)">
    <div class="overflow-table">
        <table mat-table matSort (matSortChange)="changeSorting($event)" [dataSource]="dataSource">

            <ng-container matColumnDef="CesionarioName">
                <th class="th-header" mat-sort-header mat-header-cell *matHeaderCellDef >
                    Nombre
                </th>
                <td mat-cell *matCellDef="let element" >
                    <h6> 
                        <a [routerLink]="['/dashboards/factoring', element.cesionarioCompanyId]"> {{ element.cesionarioName }} </a> <br >
                        <a [routerLink]="['/dashboards/factoring', element.cesionarioCompanyId]"> {{ element.cesionarioRut }} </a>
                    </h6>
                </td>
            </ng-container>

            <ng-container matColumnDef="ReceivedInvoices">
                <th class="th-header" mat-sort-header mat-header-cell *matHeaderCellDef >
                    Facturas Recibidas
                </th>
                <td mat-cell *matCellDef="let element">
                    <h6> {{element.receivedInvoices}}</h6>
                </td>
            </ng-container>

            <ng-container matColumnDef="TotalAmountReceivedInvoices">
                <th class="th-header" mat-sort-header mat-header-cell *matHeaderCellDef >
                    Total Recibido
                </th>
                <td mat-cell *matCellDef="let element">
                    <h6> {{element.totalAmountReceivedInvoices | currency : 'CLP'}}</h6>
                </td>
            </ng-container>

            <ng-container matColumnDef="TransferedInvoices">
                <th class="th-header" mat-sort-header mat-header-cell *matHeaderCellDef >
                    Facturas Cedidas
                </th>
                <td mat-cell *matCellDef="let element">
                    <h6> {{element.transferedInvoices}}</h6>
                </td>
            </ng-container>

            <ng-container matColumnDef="TotalAmountTransferedInvoices">
                <th class="th-header" mat-sort-header mat-header-cell *matHeaderCellDef >
                    Total Cedido
                </th>
                <td mat-cell *matCellDef="let element">
                    <h6> {{element.totalAmountTransferedInvoices | currency : 'CLP'}}</h6>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="columns"></tr>
            <tr mat-row *matRowDef="let row; columns: columns"></tr>
        </table>
    </div>
    <mat-paginator (page)="changePagination($event)" [pageSizeOptions]="[10, 25, 50, 100]"></mat-paginator>
</section>